export default {
    type: 'publication-themes',
    aliases: {
        camel: 'publicationThemes',
        singular: 'Publication theme',
        plural: 'Publication themes',
        lowerSingular: 'publication theme',
        lowerPlural: 'publication themes',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
